import { API_BASE_URL } from '../index'
import { getCookie } from '../helpers/CookieHandler'

let searchAuditId

export const auditSearch = (searchCriteriaArg, bundleSearchResults, setSearchAuditId) => {
  const allSearchedDocuments = getAllDocumentsInBundle(bundleSearchResults)

  const searchCriteria = {
    product: searchCriteriaArg.productName,
    catagory: searchCriteriaArg.category,
    scope: searchCriteriaArg.scope,
    country: searchCriteriaArg.country,
    keyword: searchCriteriaArg.keyword,
    fingerprint: getCookie('_hash'),
    topic: searchCriteriaArg.topic
  }
  const url = `${API_BASE_URL}rest/audit/search`
  fetch(url, {
    credentials: "include",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN' : getCookie('XSRF-TOKEN')
    },
    body: JSON.stringify({ searchCriteria, allSearchedDocuments })
  }).then(res => {
    if (res.status === 200) {
      res.json().then(responseJson => {
        searchAuditId = responseJson
        setSearchAuditId(searchAuditId)
      })
    }
  })
}

const getAllDocumentsInBundle = bundleSearchResults => {
  const allSearchedDocuments = []
  bundleSearchResults.forEach(({ parent }) => {
    allSearchedDocuments.push(parent)
  })

  return allSearchedDocuments
}

// Note: this function is not currently in use
export const auditDownload = downloadableDocument => {
  const url = `${API_BASE_URL}rest/audit/download`
  fetch(url, {
    credentials: "include",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN' : getCookie('XSRF-TOKEN')
    },
    body: JSON.stringify({ downloadableDocument, searchAuditId })
  }).then(res => {
    if (res.status === 200) {
      res.json().then(responseJson => {
      })
    }
  })
}

// Note: this function is not currently in use
export const auditZipDownload = downloadableDocuments => {
  const url = `${API_BASE_URL}rest/audit/downloadzip`
  const auditDownloadRequests = []
  downloadableDocuments.forEach(downloadableDocument =>
    auditDownloadRequests.push({ downloadableDocument, searchAuditId })
  )
  fetch(url, {
    credentials: "include",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN' : getCookie('XSRF-TOKEN')
    },
    body: JSON.stringify(auditDownloadRequests)
  }).then(res => {
    if (res.status === 200) {
      res.json().then(responseJson => {})
    }
  })
}

const emptyCallback = () => undefined




// WEBPACK FOOTER //
// ./src/mi-app/Audit.js